// import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import GlobleComponent from './pages/home/GlobleComponent';
import Home from './pages/home/Home';
import Features from './pages/product/Features';
import FieldOrderTakingForSalesReps from './pages/solutions/FieldOrderTakingForSalesReps';
import SelfOrderingForB2BCustomers from './pages/solutions/SelfOrderingForB2BCustomers';
import OrderManagementSoftware from './pages/solutions/OrderManagementSoftware';
import WhySelzor from './pages/why-selzor/WhySelzor';
import Pricing from './pages/pricing/Pricing';
import HowToVideos from './pages/resources/HowToVideos';
import FAQs from './pages/resources/FAQs';
import Docs from './pages/docs/Docs';
import Setup from './pages/docs/setup/Setup';
import Categories from './pages/docs/categories/Categories';
import ContactUs from './pages/contactus/ContactUs';
import AboutUs from './pages/aboutus/AboutUs';
import PreLoading from './pages/components/preloading/PreLoading';
import { useEffect, useState } from 'react';
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import TermsOfService from './pages/terms-of-service/TermsOfService';
import SellerSetup from './pages/docs/setup/SellerSetup';
import BuyerSetup from './pages/docs/setup/BuyerSetup';
import Dashboard from './pages/docs/dashboard/Dashboard';
import CategoryNesting from './pages/docs/categories/CategoryNesting';
import ReorderProducts from './pages/docs/categories/ReorderProducts';
import Products from './pages/docs/products/Products';
import ProductVariations from './pages/docs/products/ProductVariations';
import PublishProduct from './pages/docs/products/PublishProduct';
import PreperingData from './pages/docs/PreperingData/PreperingData';
import ExportExcelData from './pages/docs/ExportExcel/ExportExcelData';
import PhotoLibrary from './pages/docs/PhotoLibrary/PhotoLibrary';
import Users from './pages/docs/Users/Users';
import UserPrevelies from './pages/docs/Users/UserPrevelies';
import Distributor from './pages/docs/Distributor/Distributor';
import AddingBuyer from './pages/docs/Buyers/AddingBuyer';
import Buyers from './pages/docs/Buyers/Buyers';
import BuyerSetting from './pages/docs/Buyers/BuyerSetting';
import Suppliers from './pages/docs/Suppliers/Suppliers';
import Orders from './pages/docs/Orders/Orders';
import OrderActions from './pages/docs/Orders/OrderActions';
import OrderCarts from './pages/docs/Orders/OrderCarts';
import AdjustmentCart from './pages/docs/Orders/AdjustmentCart';
import PreviousOrders from './pages/docs/Orders/PreviousOrders';
import OrderStatus from './pages/docs/Orders/OrderStatus';
import ItemisedQuantityReport from './pages/docs/Orders/ItemisedQuantityReport';
import CompletingOrders from './pages/docs/Orders/CompletingOrders';
import OrderPreview from './pages/docs/Orders/OrderPreview';
import ExportingOrders from './pages/docs/Orders/ExportingOrders';
import ExcelImport from './pages/docs/Setting/ExcelImport';
import Badges from './pages/docs/Setting/Badges';
import StockStatus from './pages/docs/Setting/StockStatus';
import Warehouses from './pages/docs/Setting/Warehouses';
import Territories from './pages/docs/Setting/Territories';
import CustomOrderFields from './pages/docs/Setting/CustomOrderFields';
import Settings from './pages/docs/Setting/Settings';
import OrderActivity from './pages/docs/OrderActivity/OrderActivity';
import Reports from './pages/docs/Reports/Reports';
import ProjectionReport from './pages/docs/Reports/ProjectionReport';
import GeneralsSet from './pages/docs/Setting/GeneralsSet';
import PlaceOrder from './pages/docs/Orders/PlaceOrder';
import ProductAttributes from './pages/docs/Setting/ProductAttributes';
import ShareAppCode from './pages/docs/ShareAppCode/ShareAppCode';
import SpreadAWord from './pages/docs/SpreadAWord/SpreadAWord';
import ProductImage from './pages/docs/products/ProductImage';
import ProductDocument from './pages/docs/products/ProductDocument';
import ProductOffer from './pages/docs/products/ProductOffers';
import Application from './pages/Application/Application';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <PreLoading />;
  }
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<GlobleComponent />} />
        {/* <Route path='/Home' element={<Home />} /> */}
        {/* products */}
        <Route path='/features' element={<Features />} />
        {/* solutions  */}
        <Route path='/field-order-taking-for-sales-reps' element={<FieldOrderTakingForSalesReps />} />
        <Route path='/self-ordering-for-b2b-customers' element={<SelfOrderingForB2BCustomers />} />
        <Route path='/order-management-for-businesses' element={<OrderManagementSoftware />} />
        <Route path='/application' element={<Application/>} />
        {/* other menus  */}
        <Route path='/why-selzor' element={<WhySelzor />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-of-service' element={<TermsOfService />} />
        {/* resources  */}
        <Route path='/how-to-videos' element={<HowToVideos />} />
        <Route path='/frequently-asked-questions' element={<FAQs />} />

        {/* docs sidebar menus  */}
        <Route path="/documentation" element={<Docs />}>
          {/* Default content for /documentation */}
          <Route index element={<Setup />} />
          {/* Sub-routes for the content pages */}
           <Route path="setup" element={<Setup />} />
          <Route path="seller-setup" element={<SellerSetup />} />
          <Route path="buyer-setup" element={<BuyerSetup />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="category-nesting" element={<CategoryNesting />} />
          <Route path="reorder-products" element={<ReorderProducts />} />
          <Route path="categories" element={<Categories />} />
          <Route path="products" element={<Products />} />
          <Route path="ProductVariations" element={<ProductVariations />} />
          <Route path="productimage" element={<ProductImage />} />
          <Route path="productdocument" element={<ProductDocument/>} />
          <Route path="productoffer" element={<ProductOffer/>} />
          <Route path="PublishProduct" element={<PublishProduct />} />
          <Route path="PreperingData" element={<PreperingData />} />
          <Route path="ExportExcelData" element={<ExportExcelData />} />
          <Route path="PhotoLibrary" element={<PhotoLibrary />} />
          <Route path="Users" element={<Users />} />
          <Route path="UserPrevelies" element={<UserPrevelies />} />
          <Route path="Distributor" element={<Distributor />} />
          <Route path="AddingBuyer" element={<AddingBuyer />} />
          <Route path="Buyers" element={<Buyers />} />
          <Route path="BuyerSetting" element={<BuyerSetting />} />
          <Route path="Suppliers" element={<Suppliers />} />
          <Route path="Orders" element={<Orders />} />
          <Route path="OrderActions" element={<OrderActions />} />
          <Route path="OrderCarts" element={<OrderCarts />} />
          <Route path="AdjustmentCart" element={<AdjustmentCart />} />
          <Route path="previousorders" element={<PreviousOrders />} />
          <Route path="OrderStatus" element={<OrderStatus />} />
          <Route path="ItemisedQuantityReport" element={<ItemisedQuantityReport />} />
          <Route path="completingorders" element={<CompletingOrders />} />
          <Route path="OrderPreview" element={<OrderPreview />} />
          <Route path="exportingorders" element={<ExportingOrders />} />
          <Route path="ExcelImport" element={<ExcelImport />} />
          <Route path="Badges" element={<Badges />} />
          <Route path="StockStatus" element={<StockStatus />} />
          <Route path="Warehouses" element={<Warehouses />} />
          <Route path="Territories" element={<Territories />} />
          <Route path="CustomOrderFields" element={<CustomOrderFields />} />
          <Route path="Settings" element={<Settings />} />
          <Route path="GeneralsSet" element={<GeneralsSet />} />
          <Route path="OrderActivity" element={<OrderActivity />} />
          <Route path="Reports" element={<Reports />} />
          <Route path="ProjectionReport" element={<ProjectionReport />} />
          <Route path="PlaceOrder" element={<PlaceOrder />} />
          <Route path="ProductAttributes" element={<ProductAttributes />} />
          <Route path="ShareAppCode" element={<ShareAppCode />} />
          <Route path="SpreadAWord" element={<SpreadAWord />} />

        </Route>

      </Routes>
    </div>
  );
}

export default App;
